// extracted by mini-css-extract-plugin
export var header = "_u9-1";
export var maskBottom = "_u9-6";
export var maskMiddle = "_u9-7";
export var maskTop = "_u9-5";
export var root = "_u9-0";
export var scrollDownButton = "_u9-3";
export var scrollDownButtonHidden = "_u9-4";
export var viewport = "_u9-2";